/** Browser preference only: no names, business content or backend writes. */
export function releaseReadKey(organizationId: string, profileId: string, releaseId: string) {
  return `klothiq:release-read:v1:${[organizationId, profileId, releaseId].map(encodeURIComponent).join(':')}`;
}

export function readReleaseMarker(key: string, releaseId: string): boolean | null {
  try {
    return window.localStorage.getItem(key) === releaseId;
  } catch {
    return null;
  }
}

export function saveReleaseMarker(key: string, releaseId: string): boolean {
  try {
    window.localStorage.setItem(key, releaseId);
    return true;
  } catch {
    // The active component keeps its acknowledgement in memory when storage is unavailable.
    return false;
  }
}
